import api from "./client";

// Voice Configuration API
export const voiceConfigAPI = {
  // Get all voice providers
  getVoiceProviders: async () => {
    const response = await api.get("/api/v1/voice_providers");
    return response.data;
  },

  // Get voices for a specific provider
  getVoices: async (provider) => {
    const response = await api.get(
      `/api/v1/voice_providers/${provider}/voices`
    );
    return response.data;
  },

  // Get all languages
  getAllLanguages: async () => {
    const response = await api.get("/api/v1/voice_providers/get_languages");
    return response.data;
  },

  // Get voices for a specific language
  getVoicesByLanguage: async (languageId) => {
    const response = await api.get(
      `/api/v1/voice_providers/by_language?language_id=${languageId}`
    );
    return response.data;
  },

  // Get provider configs
  getProviderConfigs: async () => {
    const response = await api.get("/api/v1/voice_providers/configs");
    return response.data;
  },

  // Get background noises
  getBackgroundNoises: async () => {
    const response = await api.get(
      "/api/v1/voice_providers/background_noises"
    );
    return response.data;
  },

  // Fetch ElevenLabs voice catalog (proxied + 15-min cached on backend).
  // Returns { data: [{ id, name, language, gender, preview_url }, ...] }
  getElevenLabsVoices: async () => {
    const response = await api.get("/api/v1/voice_providers/elevenlabs/voices");
    return response.data;
  },

  // Fetch Cartesia voice catalog — same shape as ElevenLabs.
  getCartesiaVoices: async () => {
    const response = await api.get("/api/v1/voice_providers/cartesia/voices");
    return response.data;
  },
};
